@if (isTextField(field)) {
  <lgd-text [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
  </lgd-text>
}

@if (isSelectField(field)) {
  <lgd-select [controlName]="controlName" [label]="field.Caption" [options]="optionsObservable" [attr.telemetry]="ariaLabel">
  </lgd-select>
}

@if (isNumberField(field)) {
  <lgd-number [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
  </lgd-number>
}

@if (isDateField(field)) {
  <lgd-date-picker [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
  </lgd-date-picker>
}

@if (isCheckboxField(field)) {
  <lgd-checkbox [controlName]="controlName" [label]="field.Caption" [attr.telemetry]="ariaLabel">
  </lgd-checkbox>
}